import { css, Global } from '@emotion/react'
import { Cell, Grid, Heading, Theme, useTheme } from 'bold-ui'
import { PageContainer } from 'components/layout/PageContainer'
import { ExternalUserHeader, TOTAL_HEADER_HEIGHT } from 'components/user/ExternalUserHeader'
import { Fragment, ReactNode } from 'react'
import { mediaMobile } from 'util/breakpoints'

import { CameraPreview } from './CameraPreview'

interface SalaEsperaVideochamadaMobileLayoutProps {
  audioEnabled: boolean
  videoEnabled: boolean
  setAudioEnabled(value: boolean): void
  setVideoEnabled(value: boolean): void
  subtitulo?: ReactNode
  children: ReactNode
}

export function SalaEsperaVideochamadaMobileLayout(props: Readonly<SalaEsperaVideochamadaMobileLayoutProps>) {
  const { audioEnabled, videoEnabled, setAudioEnabled, setVideoEnabled, subtitulo, children } = props

  const theme = useTheme()
  const styles = createStyles(theme)

  return (
    <Fragment>
      <Global styles={styles.global} />
      <ExternalUserHeader />
      <PageContainer style={styles.container}>
        <Grid direction='column' wrap={false} style={styles.containerGrid}>
          <Cell size={12} style={styles.scrollableSection}>
            <Grid direction='column' wrap={false} style={styles.innerScrollableGrid}>
              <Cell size={12}>
                <Heading level={3}>Videochamada e-SUS APS</Heading>
                {subtitulo && <Heading level={5}>{subtitulo}</Heading>}
              </Cell>
              <Cell size={12} flexGrow={1}>
                <CameraPreview
                  audioEnabled={audioEnabled}
                  videoEnabled={videoEnabled}
                  setAudioEnabled={setAudioEnabled}
                  setVideoEnabled={setVideoEnabled}
                  isMobile
                />
              </Cell>
            </Grid>
          </Cell>
          <Cell size={12} style={styles.noScrollableSection}>
            <span css={styles.divider} />
            {children}
          </Cell>
        </Grid>
      </PageContainer>
    </Fragment>
  )
}

const createStyles = (theme: Theme) => ({
  global: css`
    #site-wrapper {
      overflow-x: clip;
      min-height: 100dvh;
      ${mediaMobile} {
        min-height: auto;
      }
    }
  `,
  container: css`
    height: calc(100dvh - ${TOTAL_HEADER_HEIGHT}rem);
    padding: 0 0.5rem;
  `,
  containerGrid: css`
    height: 100%;
    margin: 0;
  `,
  scrollableSection: css`
    overflow-y: scroll;
    overflow-x: hidden;
    height: 100%;
  `,
  innerScrollableGrid: css`
    height: 100%;
    margin-top: 0;
    padding-bottom: 0;
  `,
  noScrollableSection: css`
    margin-top: auto;
    padding-top: 1rem;
    padding-bottom: 1rem;
    position: relative;
  `,
  divider: css`
    position: absolute;
    top: 0;
    left: -0.5rem;
    width: 100vw;
    height: 1px;
    background-color: ${theme.pallete.divider};
    z-index: 1;
  `,
})
